<template>
  <Modal :title="title" v-model="visible" width="500" class="my-modal top" :mask-closable="false" :footer-hide="true">
    <div class="page-form">
      <Form :model="formData" ref="formValidate" class="page-form less" :label-width="100">
        <FormItem class="full" label="生效时间" prop="effectiveDate" :rules="$units.formRule.objRequired('请选择生效时间')">
          <DatePicker v-model="formData.effectiveDate" transfer type="date" value-format="yyyy-MM-dd" placeholder="请选择生效时间" />
        </FormItem>
        <FormItem class="full" label="变更前" prop="oldValue">
          <Select v-if="formData.type == 6" v-model="formData.oldValue" transfer>
            <Option v-for="(item, index) in groupLevelList" :value="item.value" :key="index">{{ item.label }}</Option>
          </Select>
          <lzDicSelect v-else-if="formData.type == 5" v-model="formData.oldValue" dicType="IFA_RANK" :transfer="true" clearable> </lzDicSelect>
          <Select v-else v-model="formData.oldValue" transfer clearable filterable>
            <Option v-for="(item, index) in userList" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem class="full" label="变更后" prop="newValue">
          <Select v-if="formData.type == 6" v-model="formData.newValue" transfer>
            <Option v-for="(item, index) in groupLevelList" :value="item.value" :key="index">{{ item.label }}</Option>
          </Select>
          <lzDicSelect v-else-if="formData.type == 5" v-model="formData.newValue" dicType="IFA_RANK" :transfer="true" clearable> </lzDicSelect>
          <Select v-else v-model="formData.newValue" transfer clearable filterable>
            <Option v-for="(item, index) in userList" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
        </FormItem>
      </Form>
    </div>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible = false">取消</Button>
      <Button type="primary" @click="save">确认</Button>
    </div>
  </Modal>
</template>
<script>
import dayjs from 'dayjs';
import lzDicSelect from '@/components/commons/lzDicSelect';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  props: {},
  components: {
    lzDicSelect
  },
  data() {
    return {
      options: {
        disabledDate(date) {
          return Number(dayjs(date).format('MM')) % 3 != 1;
        }
      },
      groupLevelList: [
        {
          label: '合伙人',
          value: '1'
        },
        {
          label: '高级合伙人',
          value: '2'
        }
      ],
      visible: false,
      userList: [],
      formData: {
        id: '',
        oldValue: '',
        newValue: '',
        effectiveDate: '',
        type: ''
      }
    };
  },
  computed: {
    title() {
      //	 变更类型 1=推荐关系 2=辅导关系 3=管理关系 4=育成关系
      let type = {
        1: '推荐关系',
        2: '辅导关系',
        3: '管理关系',
        4: '育成关系',
        5: '职级记录'
      };
      return type[this.formData.type] || '新增';
    }
  },
  methods: {
    getUserList() {
      this.$http({
        type: 'POST',
        url: '/buz/userBase/read/list',
        data: {
          pageSize: 9999,
          pageNo: 1,
          isAll: 1
        }
      }).then(res => {
        this.userList = res.data;
      });
    },
    save() {
      this.$refs.formValidate.validate().then(isok => {
        console.log(isok);
        if (!isok) {
          return;
        }
        let formData = {
          ...this.formData,
          checkDate: dayjs(this.formData.checkDate).format('YYYY-MM-DD'),
          year: dayjs(this.formData.year).format('YYYY')
        };
        this.$http({
          url: this.formData.id ? '/buz/userChangeRecord/edit' : '/buz/userChangeRecord/add',
          type: 'POST',
          data: formData
        })
          .then(res => {
            this.$notice.msg('操作成功');
            this.visible = false;
            this.$emit('success');
          })
          .catch(err => {
            console.error(err);
            this.$notice.msg('操作失败');
          });
      });
    },
    open(data) {
      this.getUserList();
      this.visible = true;
      this.$refs.formValidate && this.$refs.formValidate.resetFields();
      this.formData = {
        id: '',
        oldValue: '',
        newValue: '',
        effectiveDate: '',
        ...data
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.dian {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #35bf3f;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: top;
  transform: translateY(7px);

  &.red {
    background: #e3461f;
  }
}
.half {
  width: 50%;
}
/deep/.flex {
  .ivu-form-item-content {
    display: flex;
  }
}
</style>
